import {Component, inject, signal} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {RepoHubService} from '../services/repo-hub.service';
import {
  CreateInHubMessageDialogComponent
} from './create-in-app-message-hub-dialog/create-in-app-message-hub-dialog.component';
import {InHubMessage} from '../models/inHubMessage';
import {MatTabsModule} from '@angular/material/tabs';
import {MatButtonModule} from '@angular/material/button';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {Bu} from '../models/bu';
import {DatePipe, NgOptimizedImage} from '@angular/common';
import {MatTooltip} from '@angular/material/tooltip';


@Component({
  selector: 'app-in-app-messages-hub',
  imports: [
    MatTabsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    NgOptimizedImage, MatTooltip, DatePipe,
    CreateInHubMessageDialogComponent
  ],
  templateUrl: './in-app-messages-hub.component.html',
  styleUrl: './in-app-messages-hub.component.css'
})
export class InAppMessagesHubComponent {

  currentMessage: InHubMessage | null;

  bus = Bu.bus;

  repoHub = inject(RepoHubService);

  public dialog = inject(MatDialog);

  isCreateMessageVisible = signal<boolean>(false);

  displayedData = signal<{
    bu: "se",
    currentInHubMessage: InHubMessage,
  } | null>(null);

  constructor() {

    this.repoHub.inHubMessagesSubject.subscribe((res) => {
      this.currentMessage = res[0];
    })
  }

  async removeMessage() {
    await this.repoHub.removeInHubMessage();
  }


  openCreateDialog() {
    this.isCreateMessageVisible.set(true);
    this.displayedData.set({
      bu: 'se',
      currentInHubMessage: this.currentMessage
    });
  }
}
